// using this as the global state of the application
import React, { useState } from 'react'
import { MeasureDataContext } from './MeasureDataProvider'
import { AppState, TabState } from '../types'
import { convertValueFromUnitToUnit } from '../utils/converterUtils'
import Big from 'big.js'

interface AppContextProps {
  appState: AppState
  setAppState: React.Dispatch<React.SetStateAction<AppState>>
}

export const AppContext = React.createContext<AppContextProps>({
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  appState: {} as AppState,
  setAppState: () => null
})

interface Props {
  children: React.ReactNode
}

const AppProvider: React.FC<Props> = ({ children }) => {
  const { allMeasures } = React.useContext(MeasureDataContext)

  const initialTabStates: { [key: string]: TabState } = Object.fromEntries(
    Object.entries(allMeasures).map(([_, measure]) => [
      measure.codeName,
      {
        fromUnit: measure.defaultFromUnit,
        toUnit: measure.defaultToUnit,
        fromNumber: '1',
        toNumber: convertValueFromUnitToUnit(measure, new Big(1), measure.defaultFromUnit, measure.defaultToUnit).toString(),
        isConversionValid: true
      }
    ])
  )

  const [appState, setAppState] = useState<AppState>({
    currentMeasure: allMeasures.length,
    tabs: initialTabStates
  })

  const values = {
    appState,
    setAppState
  }

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>
}

export default AppProvider
